<template>
  <div class="course-create-wrap">
    <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
      <div class="info-title">
        基本信息
      </div>
      <div class="info-content" style="padding-top:25px;">
        <a-row :gutter="24">
          <a-col :md="24" :lg="16">
            <a-form :form="form" layout="vertical">
              <a-form-item
                label="法人姓名"
              >
                <a-input placeholder="请输入法人姓名" v-decorator="[
                        'legalPersonaName',
                        {rules: [{ required: true, message: '请输入法人姓名' }]},
                        {'initialValue':this.legalPersonaName}
                      ]"  />
              </a-form-item>

              <a-form-item
                label="法人微信"
              >
                <a-input placeholder="请输入法人微信" v-decorator="[
                        'legalPersonaWeChat',
                        {rules: [{ required: true, message: '请输入法人微信' }]},
                        {'initialValue':this.legalPersonaWeChat}
                      ]" />
              </a-form-item>
              <a-form-item
                label="企业名称"
              >
              <a-input placeholder="请输入企业名称" v-decorator="[
                        'companyCode',
                        {rules: [{ required: true, message: '请输入企业名称' }]},
                        {'initialValue':this.companyCode}
                      ]" />
              </a-form-item>
              <a-form-item
                label="营业执照注册号"
              >
                <a-input placeholder="请输入营业执照注册号" v-decorator="[
                        'companyCode',
                        {rules: [{ required: true, message: '请输入法人姓名' }]},
                        {'initialValue':this.companyCode}
                      ]"  />
              </a-form-item>
              
              <a-form-item>
                <a-button type="primary"  @click="createApp()">提交</a-button>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </div>
    </a-card>
  </div>
</template>

<script>
  import {fastRegisterApp} from '@/api/api';
  export default {
    components: {
      
    },
    data () {
      return {
         companyName:"",
         companyCode:"",
         codeType:"3",
         legalPersonaWeChat:"",
         legalPersonaName:"",
         form: this.$form.createForm(this),
      }
    },
    methods: {
      createApp(){
        this.form.validateFields((err, values) => {
          if (!err) {
             let valuesParam = {};
            valuesParam = {...values};

            this.fastRegisterApp(valuesParam).then((res)=>{
              
                  console.log(res);
              if(res.success==true){
                this.$message.success(res.message,()=>{

                });
                
              }else{
                this.$message.warning(res.message);
              }

            }).finally(() => {
            })

          }
        })
      }
    },
    created () {

      
      // 查询已提交信息
      // this.$nextTick(() => {
      //   this.form.setFieldsValue(pick(resultData,'companyName','companyCode',
      //   'legalPersonaWeChat','legalPersonaName'))

      // });
          
    }
  }
</script>

<style lang="scss" scoped>

 .course-create-wrap{
    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    } 

    .info-content{
      .img-tip{
        color: #999999;
        font-size: 12px;
      }
      .ant-upload-list-picture-card{
        .ant-upload-list-item{
          width:142px!important;
          height:80px;
        }
      }
      .j-teacher-list{
        .j-teacher-item{
          
          
          .j-teacher-item-con{
            width: 587px;
            padding: 20px;
            overflow: hidden;
            border: 1px solid #D0DBE4;
            display: inline-block;
            vertical-align: middle;
            .j-teacher-item-upload{
              width: 90px;
              float: left;
              .ant-upload-select-picture-card{
                width: 80px;
                height:80px;
              }
            }
            .j-teacher-item-ctx{
              margin-left:90px;
              
            }
            
          }
          .j-teacher-item-cz{
            display: inline-block;
            vertical-align: middle;
            margin-left: 35px;
            color: #0091FF;
            cursor: pointer;
          }
          
        }
      }
      .kaike-tip{
        color:#FA6400;
        font-size: 12px;
        // line-height: 1;
      }
      .kaike-radio-list{
        line-height: 1;
        .kaike-radio-item{
          line-height: 1;
          margin-bottom: 12px;
          margin-top: 0px;
        }
      }
      
    }

    
  }
</style>